import { AbstractDomComponent } from './AbstractDomComponent';
import { tag } from '../../utils/tag';
import { QuizActionEvent, QuizActionType } from '../../constants/QuizActionEvent';

export class QuestionComponent extends AbstractDomComponent {
    #data;
    #inputs;
    #rootEl;
    #handlers;
    #decor = [];

    constructor(data) {
        super();

        this.#data = data;
        this._needListeners = true;
    }

    _render(parentNode) {
        const { id, text, options } = this.#data || {};

        const rootEl = tag('section', 'question-ui');
        const mainEl = tag('div', 'question-ui__main');
        const titleEl = tag('h2', 'question-ui__ttl', 'Вопрос');
        const textEl = tag('h3', 'question-ui__text', text);
        const optionsContEl = tag('div', 'question-ui__options');

        rootEl.classList.add(`question-ui--${id}`);
        titleEl.classList.add('h2');

        rootEl.appendChild(mainEl);
        mainEl.appendChild(titleEl);
        mainEl.appendChild(textEl);
        mainEl.appendChild(optionsContEl);

        this.#inputs = options.map((option) => {
            const { id: opId, label } = option;
            const lblEl = tag('label', 'question-ui__option');
            const inputEl = tag('input', 'question-ui__option-input');
            const spanEl = tag('span', 'question-ui__option-text', label);

            inputEl.setAttribute('type', 'radio');
            inputEl.setAttribute('name', id);
            inputEl.setAttribute('id', opId);
            inputEl.setAttribute('value', opId);

            lblEl.appendChild(inputEl);
            lblEl.appendChild(spanEl);
            optionsContEl.appendChild(lblEl);

            return inputEl;
        });
        this.#rootEl = rootEl;

        parentNode.appendChild(rootEl);

        this.#addDecorations();

        return [rootEl];
    }

    appendComment(commentComponent) {
        const mainEl = tag('div', 'question-ui__answer');

        commentComponent.renderTo(mainEl);

        this.#rootEl.appendChild(mainEl);
        this.disableOptions();
    }

    disableOptions() {
        if (this.#inputs) {
            this.#inputs.forEach((input) => input.setAttribute('disabled', 'true'));
        }
    }

    remove(clear) {
        this.#removeDecorations();
        super.remove(clear);

        if (clear) {
            this.#rootEl = null;
            this.#inputs = null;
            this.#decor.splice(0, this.#decor.length);
        }
    }

    _addListeners() {
        if (!this.#inputs) return;

        if (this.#handlers) this._removeListeners();

        this.#handlers = this.#inputs.map((input, index) => {
            const changeHandler = () => {
                this.dispatchEvent({
                    type: 'change',
                    optionIndex: index,
                    value: input.value
                });
            };

            const keydownHandler = (evt) => {
                const { code } = evt;

                // ENTER
                if (code === 'Enter') {
                    const checked = this.#inputs.filter((inpt) => inpt.checked);

                    if (!checked || checked.length < 1) return;

                    this.dispatchEvent({
                        type: QuizActionEvent,
                        action: {
                            type: QuizActionType.ANSWER,
                            value: checked[0].value,
                            questionId: this.#data.id
                        }
                    });
                }
            };

            input.addEventListener('change', changeHandler);
            input.addEventListener('keydown', keydownHandler);

            return { changeHandler, keydownHandler };
        });
    }

    _removeListeners() {
        if (!this.#inputs || !this.#handlers) return;

        this.#handlers.forEach(({ changeHandler, keydownHandler }, i) => {
            const input = this.#inputs[i];

            input.removeEventListener('change', changeHandler);
            input.removeEventListener('keydown', keydownHandler);
        });
        this.#handlers.splice(0, this.#handlers.length);
    }

    decorateBefore(decorElement) {
        this.#decor.push(decorElement);
        if (this.#rootEl) this.#rootEl.prepend(decorElement);
    }

    #addDecorations() {
        if (!this.#rootEl) return;

        this.#decor.forEach((el) => this.#rootEl.prepend(el));
    }

    #removeDecorations() {
        this.#decor.forEach((el) => { if (el.parentNode) el.parentNode.removeChild(el); });
    }

    get data() {
        return this.#data;
    }

    set data(value) {
        this.#data = value;
    }
}
